export default class scrollTo {

    constructor(e) {
        
        const logo = document.querySelector('.navigation__logo-img');
        const logoOffset = parseInt(window.getComputedStyle(logo).height);

        if( window.location.hash ) {
            
            const target = document.querySelector(window.location.hash);
            const targetScroll = document.querySelector(`[data-scroll='${window.location.hash.substring(1)}']`);
            
            if ( target || targetScroll) {

                const scroll = target ? target : targetScroll;
                const offsetPosition = scroll.getBoundingClientRect().top + window.pageYOffset - logoOffset - 130;
                window.scrollTo({
                    block: 'start',
                    top: offsetPosition,
                    behavior: "smooth"
                });            
            }
            
        }
        
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {

            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                
                const offsetPosition = document.querySelector(anchor.getAttribute('href')).getBoundingClientRect().top + window.pageYOffset - logoOffset - 70;
                
                window.scrollTo({
                    block: 'start',
                    top: offsetPosition,
                    behavior: "smooth"
                });
            });
        });
        
    }
}
window.addEventListener('DOMContentLoaded', () => new scrollTo);
